// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestCheckBox{

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _TestCheckBox?:vf.gui.CheckBox;

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {


         /** 复选框 */
         const checkbox = this.getNewCheckBox(uiStage);
         checkbox.checked=false;
         checkbox.value = "1";
         checkbox.style.left=600;
         checkbox.style.top=200;
         checkbox.text="";
         checkbox.value="";
         checkbox.checkGroup="";

 
         //单选,通过设置分组区分
         const radio = this.getNewRadio(uiStage);
         radio.checked = false;
         radio.style.left=600;
         radio.style.top=250;
         radio.text="";
         radio.value="";
         radio.checkGroup="";



         this.getButton('设置/取消text', () => {
            if ( checkbox.text!="Hello World"&&radio.text!="Hello World" ) {
                        
                checkbox.text="Hello World";
                radio.text="Hello World";

            } else {

                checkbox.text="";
                radio.text="";
            }
        }, uiStage, 15, 0);



        this.getButton('设置/取消value', () => {
            if ( checkbox.value!="Hello World"&&radio.value!="Hello World" ) {
                        
                checkbox.value="Hello World";
                radio.value="Hello World";
                console.log(checkbox.value);
                console.log(radio.value);

            } else {

                checkbox.value="";
                radio.value="";
                console.log(checkbox.value);
                console.log(radio.value);
            }
        }, uiStage, 15, 0);



        this.getButton('设置/取消heckGroup', () => {
            if ( checkbox.checkGroup!="a1"&&radio.checkGroup!="a1") {
                        
                checkbox.checkGroup="a1";
                radio.checkGroup="a1";
                console.log(checkbox.checkGroup);
                console.log(checkbox.checkGroup);

            } else {

                checkbox.checkGroup="";
                radio.checkGroup="";
                console.log(checkbox.checkGroup);
                console.log(checkbox.checkGroup);
            }
        }, uiStage, 15, 0);



        this.getButton('设置/取消checked', () => {
            if ( checkbox.checked!=true&&radio.checked!=true ) {
                        
                checkbox.checked=true;
                radio.checked=true;

            } else {

                checkbox.checked=false;
                radio.checked=false;
            }
        }, uiStage, 15, 0);


        this.getButton('设置/取消up', () => {
            if ( checkbox.up!=""&&radio.up!="" ) {
                        
                checkbox.up="";
                radio.up="";

            } else {

                checkbox.up="assets/skin/CheckBox/unselect.png";
                radio.up="assets/skin/Radio/unselect.png";
            }
        }, uiStage, 15, 0);



        this.getButton('设置/取消down', () => {
            if ( checkbox.down!=""&&radio.down!="" ) {
                        
                checkbox.down="";
                radio.down="";

            } else {

                checkbox.down="assets/skin/CheckBox/unselect.png";
                radio.down="assets/skin/Radio/unselect.png";
            }
        }, uiStage, 15, 0);



        this.getButton('设置/取消move', () => {
            if ( checkbox.move!=""&&radio.move!="" ) {
                        
                checkbox.move="";
                radio.move="";

            } else {

                checkbox.move="assets/skin/CheckBox/unselect.png";
                radio.move="assets/skin/Radio/unselect.png";
            }
        }, uiStage, 15, 0);


        this.getButton('设置/取消upAndSelected', () => {
            if ( checkbox.upAndSelected!=""&&radio.upAndSelected!="" ) {
                checkbox.checked=true;
                radio.checked=true;
                        
                checkbox.upAndSelected="";
                radio.upAndSelected="";

            } else {
                checkbox.checked=false;
                radio.checked=false;

                checkbox.upAndSelected="assets/skin/CheckBox/select_up.png";
                radio.upAndSelected="assets/skin/Radio/select_up.png";
            }
        }, uiStage, 15, 0);



        this.getButton('设置/取消downAndSelected', () => {
            if ( checkbox.down!=""&&radio.down!="" ) {

                checkbox.checked=true;
                radio.checked=true;
                        
                checkbox.downAndSelected="";
                radio.downAndSelected="";

            } else {

                checkbox.checked=false;
                radio.checked=false;

                checkbox.downAndSelected="assets/skin/CheckBox/select_down.png";
                radio.downAndSelected="assets/skin/Radio/select_down.png";
            }
        }, uiStage, 15, 0);


        let b3:boolean = false;
        let btn3 = this.getButton('设置/取消CHANGE事件', ()=>{

            if (!b3) {

                b3=true;
                checkbox.on(vf.gui.Interaction.ComponentEvent.CHANGE,  hoverFun3);
               
            } else {
                b3=false;
                checkbox.on(vf.gui.Interaction.ComponentEvent.CHANGE,  hoverFun3);
                // basicText.style.left = 600;
                // basicText.style.top = 250;
            }
            checkbox.checked =true;
           
        }, uiStage, 15, 0 ,);

       function hoverFun3(){
        // checkbox.style.left+=60;
        checkbox.style.scaleX = 3;
        //  checkbox.style.top+=20 ;
        }



        this.getButton('设置/取消moveAndSelected', () => {
            if ( checkbox.moveAndSelected!=""&&radio.moveAndSelected!="" ) {

                checkbox.checked=true;
                radio.checked=true;
                        
                checkbox.moveAndSelected="";
                radio.moveAndSelected="";

            } else {

                checkbox.checked=true;
                radio.checked=true;
                checkbox.moveAndSelected="assets/skin/CheckBox/select_down.png";
                radio.moveAndSelected="assets/skin/Radio/select_down.png";
            }
        }, uiStage, 15, 0);



    //     let b2:boolean = false;
    //     let btn2 = this.getButton('设置/取消 CHANGE事件', ()=>{
    //         if (!b2) {
    //             b2=true;
    //             checkbox.checked=true;
    //             checkbox.on(vf.gui.CheckBox.ComponentEvent.CHANGE,  hoverFun2);
               
    //         } else {
    //             b2=false;
    //             checkbox.off(vf.gui.Interaction.ComponentEvent.CHANGE,  hoverFun2);
    //             checkbox.style.left=600;
    //             radio.style.left=250;
             
    //         }
    //     }, uiStage, 15, 0 ,);

    //    function hoverFun2(){
    //     checkbox.style.left +=150;
    //     radio.style.left+=50;
    //     }












    




   
    }

    private getNewCheckBox(uiStage: vf.gui.Stage) {
        const checkbox =this._TestCheckBox= new vf.gui.CheckBox();
        checkbox.style.top = 100;
        checkbox.style.left = 100;
        checkbox.style.width = 23;
        checkbox.style.height = 23;
        checkbox.up = "assets/skin/CheckBox/unselect.png";
        checkbox.down = "assets/skin/CheckBox/unselect.png";
        checkbox.move = "assets/skin/CheckBox/unselect.png";
        checkbox.disabled = "assets/skin/CheckBox/unselect.png";
        checkbox.upAndSelected = "assets/skin/CheckBox/select_up.png";
        checkbox.downAndSelected = "assets/skin/CheckBox/select_down.png";
        checkbox.moveAndSelected = "assets/skin/CheckBox/select_down.png";
        checkbox.disabledAndSelected = "assets/skin/CheckBox/select_disabled.png";
        checkbox.on(vf.gui.Interaction.ComponentEvent.CHANGE, this.onChange, this);
        uiStage.addChild(checkbox);
        return checkbox;
    }


    private getNewRadio(uiStage: vf.gui.Stage) {
        const radio = this._TestCheckBox=new vf.gui.CheckBox();
        radio.style.top = 150;
        radio.style.left = 100;
        radio.style.width = 22;
        radio.style.height = 22;
        radio.up = "assets/skin/Radio/unselect.png";
        radio.down = "assets/skin/Radio/unselect.png";
        radio.move = "assets/skin/Radio/unselect.png";
        radio.disabled = "assets/skin/Radio/unselect.png";
        radio.upAndSelected = "assets/skin/Radio/select_up.png";
        radio.downAndSelected = "assets/skin/Radio/select_down.png";
        radio.moveAndSelected = "assets/skin/Radio/select_down.png";
        radio.disabledAndSelected = "assets/skin/Radio/select_disabled.png";
        radio.on(vf.gui.Interaction.ComponentEvent.CHANGE, this.onChange, this);
        uiStage.addChild(radio);
        return radio;
    }


    private onChange(checkBox: vf.gui.CheckBox) {
        console.log("->", checkBox.value, checkBox.checked);
    }



    


    private posY = 10;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick,  fun);
        target.addChild(button);
        this.posY = this.posY + 25 + y;

        return button;
    }



    private onRelease(){
        if(this._TestCheckBox){
            this._TestCheckBox.removeAllListeners();
            this._TestCheckBox.release();
            this._TestCheckBox=undefined;
         }
    }

        


}
